var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddDocumentPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14286 10.3125H10.2857V5.25C10.2857 4.62879 10.7975 4.125 11.4286 4.125H12.5714C13.2025 4.125 13.7143 4.62879 13.7143 5.25V10.3125H18.8571C19.4882 10.3125 20 10.8163 20 11.4375V12.5625C20 13.1837 19.4882 13.6875 18.8571 13.6875H13.7143V18.75C13.7143 19.3712 13.2025 19.875 12.5714 19.875H11.4286C10.7975 19.875 10.2857 19.3712 10.2857 18.75V13.6875H5.14286C4.51178 13.6875 4 13.1837 4 12.5625V11.4375C4 10.8163 4.51178 10.3125 5.14286 10.3125Z",
    fill: "#270ADC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDocumentPlus);
export default __webpack_public_path__ + "static/media/AddDocumentPlus.ee745b84a7ce25e6e997da84436ef235.svg";
export { ForwardRef as ReactComponent };